module.exports = __webpack_public_path__ + "d48ff8faff3a44843a773400a3b2365b.pdf";